<template>
  <v-app-bar
    app
    dense
    shrink-on-scroll
    :height="isMobile?250:450"
    color="isYellow"
    :src="require('@/assets/DSM_Bild_Header.png')"
    fade-img-on-scroll
    flat
    class="overflow-hidden"
  >
  <v-container style="height:100%;padding:0;max-width: 1400px;">
    <v-row style="height:100%;max-width:100%" justify="center" no-gutters>
      <v-col
        cols="1"
      >
        <a :href="activeLang === 'de' ? 'https://dsm.museum/':'https://www.dsm.museum/en/'" style="z-index:99">
          <v-img
              :src="'img/DSM_Logo_'+activeLang+'_2x.png'"
              max-height="101"
              :width="isMobile?'14%':'30%'"
              max-width="307"
              contain
              :style="isMobile?'position:absolute;top:11px;':'position:absolute;top:30px;'"
          ></v-img>
        </a>
      </v-col>
      <v-col
        cols="10"
        class="justify-center"
      >
      <v-row justify="center" no-gutters align="center" style="height:100%;max-width:100%;z-index:-1;">
        <v-col
          cols="auto"
          md="8"
        >
          <p v-if="de" :class="headerClass + ' text-uppercase font-weight-bold'" :style="headerStyle">
            Eine Ausstellung <br />
            Oldenburger Schüler*innen
          </p>
          <p v-if="en" :class="headerClass + ' text-uppercase font-weight-bold'" :style="headerStyle">
            An exhibition <br />
            by students in Oldenburg
          </p>
          <img
            :style="isMobile?'width:1036px; max-width:100%;':'width:1036px; max-width:70%;'"
            src="@/assets/DSM_IntoxicatingSpaces_Logo_2x.png"
            />
            <p v-if="de" :class="headerClass + ' font-weight-bold'" :style="headerStyle">
              im Rahmen des EU-Projektes Intoxicating Spaces -<br />
              The Impact of New Intoxicants on Urban Spaces in Eutope, 1600-1850
            </p>
            <p v-if="en" :class="headerClass + ' font-weight-bold'" :style="headerStyle">
              As part of the EU project Intoxicating Spaces -<br />
              The Impact of New Intoxicants on Urban Spaces in Eutope, 1600-1850
            </p>
            <br v-if="isMobile" />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="1"
      >
        <v-btn
          :style="isMobile?'top:0;font-weight:bold;right:0;padding: 0px 5px;min-width:unset;width:60px':'top:0;padding-top:0px;font-weight:bold;'"
          :class="isMobile?'':'langBtn'"
          color="warning"
          :width="isMobile?77:100"
          :height="isMobile?34:60"
          tile
          absolute
          dark
          depressed
          x-large
          @click="$emit('changeLang')"
         >{{lang}}</v-btn>
      </v-col>
    </v-row>
    <v-row style="position: absolute;width: 50%;left:0;bottom: 56px;margin:0;height:50px;">
      <v-spacer></v-spacer>
      <v-col align-self="end" style="padding-bottom:0">
          <v-spacer></v-spacer>
          <ResHL class="isBlueTXT touchy" style="text-align: right">
            Cäcilienschule
          </ResHL>
          <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-row style="position: absolute;width: 50%;bottom: 56px; right:0;margin:0;height:50px;">
      <v-col align-self="end" style="padding-bottom:0;width:100%">
          <v-spacer></v-spacer>
          <ResHL class="isRedTXT touchy">
            Altes Gymnasium
          </ResHL>
          <!--<p :class="schoolClass + ' school text-uppercase font-weight-bold'" style="color:#cc0f76">
            Altes Gymnasium
          </p>-->
          <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row style="position: absolute;width: 50%;left:0;bottom: 0;background-color:#56BCD4;margin:0;height:56px;">
      <v-spacer></v-spacer>
      <v-col align-self="end" :style="isMobile?'padding: 12px 5px;':''">
        <v-toolbar-items style="height:33px">
          <v-spacer></v-spacer>
          <v-btn
            :class="'menuBTN ' + btnClass"
            v-for="item in leftMenu"
            text
            dark
            depressed
            x-large
            :key="item.to"
            :to="item.to">
            {{ item[activeLang] }}
          </v-btn>
        </v-toolbar-items>
      </v-col>
    </v-row>
    <v-row style="position: absolute;width: 50%;bottom: 0; right:0;background-color:#cc0f76;margin:0;height:56px;">
      <v-col align-self="end" :style="isMobile?'padding: 12px 5px;':''">
        <v-toolbar-items style="height:33px">
          <v-btn
            :class="'menuBTN ' + btnClass"
            v-for="item in rightMenu"
            text
            dark
            depressed
            :key="item.to"
            :to="item.to">
            {{ item[activeLang] }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar-items>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
  </v-app-bar>
</template>
<style scoped>
  p{
    text-align:center;
  }
  .menuBTN{
    /*font-weight: bold !important;
    padding-bottom:3px !important;
    font-size: large !important;*/
    text-transform:none;
  }
  .menuBTNSmall{
      padding: 3px !important;
      min-width: 0!important;
      font-weight: bold !important;
      font-size: 0.45em !important;
  }
</style>
<style>
  .v-sheet.v-app-bar.v-toolbar {
    font-size: 1.5rem !important;
  }
  .langBtn{
    z-index: 99;
  }
  .menuBTNSmall span{
    font-size: 1em !important;
  }
</style>
<script>
import ResHL from './ResHL'
export default {
  name: 'Bar',
  components: {
    ResHL
  },
  props: {
    rightMenu: {
      type: Array,
      required: true
    },
    leftMenu: {
      type: Array,
      required: true
    },
    activeLang: {
      type: String,
      required: false
    }
  },
  computed: {
    headerStyle () {
      return this.isMobile?'line-height:110%;margin-bottom: 3px':'line-height:110%';
    },
    isMobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    de () {
      return this.activeLang === 'de';
    },
    en () {
      return this.activeLang !== 'de';
    },
    lang () {
      return this.activeLang === 'de' ? 'en' : 'de'
    },
    schoolClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'text-h5'
        case 'sm': return 'text-h5'
        case 'md': return 'text-h4'
        default: return 'text-h3'
      }
    },
    headerClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'text-caption'
        case 'sm': return 'text-subtitle-1'
        case 'md': return 'text-h6'
        default: return 'text-h6'
      }
    },
    btnClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'menuBTNSmall'
        default: return 'text-md-h6 text-body-2 text-sm-subtitle-2'
      }
    }
  }
}
</script>
